module.exports = __webpack_public_path__ + "static/logoDalhousie-b901eaa9cc7f42614b268da973f97980.jpg";